<template>
  <div>
    <div class="container-fluid bg"></div>
    <div class="container">
      <div class="row content">
        <div class="col-md-12 text-justify">
          <h1 class="centered">Курсы</h1>
          <br>
          <p class="font-italic">
            «Курсы экскурсоводов по Санкт-Петербургу» – это профессиональный курс для тех, кто хочет сделать хобби своей основной профессией, пополнить арсенал знаний, сдать обязательную Аттестацию экскурсоводов. 
Курс разработан в соответствии с Федеральным законом «Об основах туристской деятельности в Российской Федерации».
          </p>
          <p>
            Наши преимущества:
          </p>
          <ul>
            <li>возможность трудоустройства в компанию по приему туристов в Санкт-Петербурге;</li>
            <li>отдельный курс лекций, посвященный методике экскурсионной деятельности;</li>
            <li>индивидуальная работа по составлению текста экскурсии с опытным методистом;</li>
            <li>лекции читают научные сотрудники крупнейших музеев Санкт-Петербурга;</li>
			<li>преподаватели ведущих ВУЗов нашего города; практикующие экскурсоводы «Тари Тур», туроператора по приему туристов в Санкт-Петербурге;</li>
            <li>возможность подготовки к проведению экскурсии на экскурсионном тренажере;</li>
            <li>в курс входят учебные и зачетные экскурсии;</li>
			<li>предоставляются методические и информационно-справочные материалы;</li>
			<li>осуществляется подготовка к Аттестации;</li>
			<li>слушатели могут смотреть пропущенные лекции в видео-записи.</li>
          </ul>
          <p>
            Наши курсы — это действительно фундаментальное образование, а не поверхностный взгляд на историю и культуру нашего города. Своей миссией мы считаем формирование нового поколения петербургских экскурсоводов для поддержания традиций и культуры нашего города. 
          </p>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  background-image: url(../assets/books.jpeg);
  background-position: 50% 70%;
  background-size: cover;
  height: 40vh;
}
</style>



// WEBPACK FOOTER //
// AboutCourses.vue?3e17386b